import React, { useState, useEffect } from "react";
import { Layout, Switch, Menu, Select } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { createHashHistory } from "history";
import "./index.scss";
import moment from "moment";
import logo from '../../assets/logo.png';
import fullScreenIcon from '../../assets/fullScreen.png';
import unfullScreenIcon from '../../assets/unfullScreen.png';

const { Header } = Layout;
const { SubMenu } = Menu;
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(
  ({ weaDay, tem = 20, dispatch, mapStyle }) => {
    const history = createHashHistory();
    const [time, setTime] = useState(moment().format("HH:mm"));
    const [date, setDate] = useState(moment().format("YYYY年MM月DD日"));
    const [week, setWeek] = useState(moment().format("E"));
    const [img, setImg] = useState(null);
    const [current, setCurrent] = useState('/screen');
    const [select_current, setSelect_current] = useState('/screen');
    const [isFfullScreen, setFullScreen] = useState(0); //默认不是全屏


    useEffect(() => {
      const pathname = history.location.pathname;
      setCurrent(pathname);
      setSelect_current(pathname);
    }, [])


    // const returnWeek = (week) => {
    //   switch (week) {
    //     case "1":
    //       return "星期一";
    //     case "2":
    //       return "星期二";
    //     case "3":
    //       return "星期三";
    //     case "4":
    //       return "星期四";
    //     case "5":
    //       return "星期五";
    //     case "6":
    //       return "星期六";
    //     case "7":
    //       return "星期日";
    //   }
    // };
    // useEffect(() => {
    //   document.addEventListener('fullscreenchange', exitHandler);
    //   document.addEventListener('webkitfullscreenchange', exitHandler);
    //   document.addEventListener('mozfullscreenchange', exitHandler);
    //   document.addEventListener('MSFullscreenChange', exitHandler);
    //   return () => {
    //     document.removeEventListener('fullscreenchange', exitHandler);
    //     document.removeEventListener('webkitfullscreenchange', exitHandler);
    //     document.removeEventListener('mozfullscreenchange', exitHandler);
    //     document.removeEventListener('MSFullscreenChange', exitHandler);
    //   }

    // }, [])


    // const exitHandler = () => {
    //   if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
    //     setFullScreen(0);
    //   }
    // }

    useEffect(() => {
      setInterval(() => {
        setTime(moment().format("HH:mm:ss"));
        setDate(moment().format("YYYY年MM月DD日"));
        setWeek(moment().format("E"));
      }, 1000);
    }, []);
    // useEffect(() => {
    //   let img = null;
    //   try {
    //     img = require(`../../assets/weather/${weaDay}.png`)
    //   } catch (e) {
    //     img = require(`../../assets/weather/晴.png`)
    //   }
    //   setImg(weaDay ? img : "");
    // }, [weaDay]);

    /**
     * @description 全屏
     */
    // const fullScreen = () => {
    //   setFullScreen(1);
    //   let ele = document.querySelector("#root");
    //   if (ele.requestFullscreen) {
    //     ele.requestFullscreen();
    //   } else if (ele.mozRequestFullScreen) {
    //     ele.mozRequestFullScreen();
    //   } else if (ele.webkitRequestFullscreen) {
    //     ele.webkitRequestFullscreen();
    //   } else if (ele.msRequestFullscreen) {
    //     ele.msRequestFullscreen();
    //   }
    // };
    /**
     * @description 退出全屏
     */
    // const cancelFullScreen = () => {
    //   setFullScreen(0);
    //   if (document.exitFullscreen) {
    //     document.exitFullscreen();
    //   }
    //   else if (document.msExitFullscreen) {
    //     document.msExitFullscreen();
    //   }
    //   else if (document.mozCancelFullScreen) {
    //     document.mozCancelFullScreen();
    //   }
    //   else if (document.webkitCancelFullScreen) {
    //     document.webkitCancelFullScreen();
    //   }
    // };

    return (
      <Header className="header-box2 relative">
        <div className='logo_wrapper flex alignItemCenter'>
          {/* <img src={logo} alt="" /> */}
          <span className="font16 logoText">绵阳经开水务有限责任公司</span>
        </div>
        <div className="header-title">
          <span>绵阳经开区智慧化循环利用污水处理厂</span>
        </div>
        <div className="flex flexBetween header_right">
          <div className='weather_wrapper flex'>
            <div>
              <div className="numberFont font24">{date}&nbsp;&nbsp;{time}</div>
            </div>
          </div>
        </div>

      </Header>
    );
  }
);
